import { CalendarDays, ClipboardList, FileText, Send, Users } from "lucide-react";
import EventsProcess from "../eventsExperiences/EventsProcess";

const STEPS = [
  { icon: ClipboardList, title: "Understand", desc: "We learn about your brand, event, audience and objectives." },
  { icon: Users, title: "Match", desc: "We shortlist the right celebrity options based on your goals." },
  { icon: FileText, title: "Lock", desc: "We manage negotiations, contracts and all the details." },
  { icon: CalendarDays, title: "Plan", desc: "We handle travel, schedules, production and coordination." },
  { icon: Send, title: "Execute", desc: "We ensure a smooth and impactful experience from start to finish." },
];

// Same numbered steps as the Events & Experiences page (five here).
const CelebProcess = () => (
  <EventsProcess
    steps={STEPS}
    eyebrow="How it works"
    title="From brief to"
    accent="the big moment."
    intro="A simple and structured process to bring the right celebrity collaboration to life."
  />
);

export default CelebProcess;
